module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "title": _vm.modalTitle,
      "open": _vm.isOpen,
      "saveText": _vm.modalSaveText
    },
    on: {
      "save": _vm.fileUpload,
      "cancel": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "user-xls-invite"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t('ui.users.xls_invite_description')) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('ui.users.xls_invite_format')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "xls-upload"
  }, [_c('upload-field', {
    on: {
      "change": _vm.fileChange
    }
  })], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "errors"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1995fa37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/UserXlsInvite.vue
// module id = 1826
// module chunks = 0